import { render, staticRenderFns } from "./GuardianEmails.vue?vue&type=template&id=00e6c4a7&scoped=true"
import script from "./GuardianEmails.vue?vue&type=script&lang=js"
export * from "./GuardianEmails.vue?vue&type=script&lang=js"
import style0 from "./GuardianEmails.vue?vue&type=style&index=0&id=00e6c4a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6c4a7",
  null
  
)

export default component.exports